import { render, staticRenderFns } from "./FormNewOrgLure.vue?vue&type=template&id=2a7cc56c&"
import script from "./FormNewOrgLure.vue?vue&type=script&lang=js&"
export * from "./FormNewOrgLure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports